export default build =>
    build.query({
        tagTypes: ['allProducts'],
        keepUnusedDataFor: 1,
        query(payload) {
           // console.log("payload in get all products",payload)            
            return {
                url: `/product/getAllProducts?page_number=${payload.page_number}&page_size=${payload.page_size}`,
              //  url: `/product/getAllProducts`,
                method: 'GET'              
            };
           
        },
       providesTags: ['allProducts']
    })
